// Shared valmislause UI pieces used both by the report editor's insert
// modal (LexicalShowcase.jsx) and the Tekstisuositukset/Raportit admin
// view (ValmislauseAdmin.jsx) — kept here once so the two stay visually
// identical instead of drifting into two near-copies.
import { CONDITION_PARAMS, NUMBER_OPS, STRING_OPS, extractParamValue } from '../utils/valmislauseStorage';

// Tag names are free text — just trimmed, no forced case or character
// substitution.
export const sanitizeTagName = (raw) => raw.trim();

// The JOS <param> <op> <value> row, shared by the new-sentence form and
// by editing an existing sentence's condition — same fields either way.
export function ConditionFields({ param, op, val, onParamChange, onOpChange, onValChange, rakennusData, mergedRakennusData }) {
  const paramDef = CONDITION_PARAMS.find(d => d.key === param);
  const ops = paramDef?.type === 'string' ? STRING_OPS : NUMBER_OPS;
  return (
    <div className="d-flex gap-1 align-items-center flex-wrap">
      <span style={{ fontSize: '0.82rem', color: '#6c757d', whiteSpace: 'nowrap' }}>JOS</span>
      <select className="form-select form-select-sm" style={{ flex: 2, minWidth: 120, fontSize: '0.84rem' }}
        value={param} onChange={e => onParamChange(e.target.value)}>
        {CONDITION_PARAMS.map(p => {
          const cur = rakennusData || mergedRakennusData ? extractParamValue(p.key, rakennusData, mergedRakennusData) : null;
          return <option key={p.key} value={p.key}>{p.label}{cur != null ? ` (nyt: ${cur})` : ''}</option>;
        })}
      </select>
      <select className="form-select form-select-sm" style={{ flex: 1, minWidth: 90, fontSize: '0.84rem' }}
        value={op} onChange={e => onOpChange(e.target.value)}>
        {ops.map(o => <option key={o.op} value={o.op}>{o.label}</option>)}
      </select>
      <input
        className="form-control form-control-sm" style={{ width: 80, fontSize: '0.84rem' }}
        type={paramDef?.type === 'number' ? 'number' : 'text'}
        value={val} onChange={e => onValChange(e.target.value)}
      />
    </div>
  );
}

// Renders a saved valmislause's title/teksti with its {{param_key}}
// placeholders as small pills (the param's label, not the raw key) instead
// of raw "{{huoneistojen_lkm}}" text — so a token reads as "this is a
// variable" at a glance everywhere a sentence's text is listed.
export function renderWithMuuttujat(text) {
  if (!text) return text;
  return text.split(/(\{\{\w+\}\})/g).map((part, i) => {
    const m = part.match(/^\{\{(\w+)\}\}$/);
    if (!m) return part;
    const def = CONDITION_PARAMS.find(p => p.key === m[1]);
    return (
      <span key={i} title={part} style={{
        display: 'inline-block', fontSize: '0.78em', fontWeight: 700,
        color: '#4338ca', background: '#eef2ff', border: '1px solid #c7d2fe',
        borderRadius: 999, padding: '0 7px', margin: '0 1px', whiteSpace: 'nowrap',
      }}>
        {def?.label ?? part}
      </span>
    );
  });
}
